import { AppConfigurationKey } from "../../../../model/enums/appConfigurationKey";
import { getAppConfigurationValue } from "../../../../redux";
import AxiosInstance from "../../../http-config";
import { Operand } from "./model/operand";

export const fetchOperands = async (): Promise<Operand[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia);

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/operands`
  ).then(response => {
    return response.data;
  });
};